import {Routes} from '@angular/router'
import {
  AUTOGIRO_ROUTE_PATH,
  DOCUMENTS_ROUTE_PATH,
  KYC_ROUTE_PATH,
  LETTER_ROUTE_PATH,
  LOAN_ROUTE_PATH,
  START_ROUTE_PATH
} from './application/data-types'
import {CodeComponent} from './common/code/code.component'
import {ClosedComponent, closedGuard} from '@sparbanken-syd/sparbanken-syd-theme'

export default [
  /**
   * Go here if we are closed for maintenance
   */
  {
    path: 'closed',
    component: ClosedComponent
  },
  {
    path: '',
    canActivateChild: [closedGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: START_ROUTE_PATH
      },
      {
        /**
         * Very special path. That snoops the '#' from the url
         * sends the code to be and then routes to "documents"
         */
        path: 'code',
        component: CodeComponent
      },
      {
        path: START_ROUTE_PATH,
        loadComponent: () => import('./0-start/start/start.component').then(c => c.StartComponent)
      },
      {
        path: DOCUMENTS_ROUTE_PATH,
        loadChildren: () => import('./2-documents/documents-routes')
      },
      {
        path: AUTOGIRO_ROUTE_PATH,
        loadComponent: () => import('./3-autogiro/autogiro/autogiro.component').then(c => c.AutogiroComponent)
      },
      {
        path: LETTER_ROUTE_PATH,
        loadChildren: () => import('./4-letters/letters-routes')
      },
      {
        path: LOAN_ROUTE_PATH,
        loadChildren: () => import('./5-loans/user-routes')
      },
      {
        path: KYC_ROUTE_PATH,
        loadChildren: () => import('./6-kyc/kyc-routes')
      },
      {
        path: 'impersonate',
        loadComponent: () => import('./7-admin/start/start.component').then(c => c.StartComponent)
      },
      {
        path: 'impersonate/:sub',
        loadComponent: () => import('./7-admin/start/start.component').then(c => c.StartComponent)
      },
      {
        path: '**',
        redirectTo: START_ROUTE_PATH
      }
    ]
  }
] satisfies Routes
